import { adminPath, type AdminClient } from '../core/index.js'
import type { AdminWorkerSearchHit, WorkerProfile, WorkerSearchResults, WorkerTableRow } from './types.js'

/** The roster module's admin calls: rosters, profiles and the search that spans every client. */
export interface RosterAdminApi {
  /** A facility's roster, in the same shape the operator dashboard's worker table uses. */
  listFacilityWorkers(clientId: string, facilityId: string): Promise<WorkerTableRow[]>
  /** One worker's profile, read-only; 404 for a worker that client does not have. */
  workerProfile(clientId: string, workerId: string): Promise<WorkerProfile>
  /** Workers found by `query` - the start of a name, of a word in it, or of an id - across every client. `query` must be at least three characters. */
  searchWorkers(query: string): Promise<WorkerSearchResults<AdminWorkerSearchHit>>
}

export function createRosterAdminApi(client: AdminClient): RosterAdminApi {
  return {
    listFacilityWorkers: (clientId, facilityId) => client.call('GET', `${adminPath.facility(clientId, facilityId)}/workers`),
    workerProfile: (clientId, workerId) => client.call('GET', adminPath.worker(clientId, workerId)),
    searchWorkers: (query) => client.call('GET', `/admin/workers?q=${encodeURIComponent(query)}`),
  }
}
